import React from 'react';
import { Link } from 'react-router-dom';
import {
    Layout, Breadcrumb, message, Spin, Descriptions, Button, Divider
} from 'antd';
import { HomeOutlined, RightOutlined } from '@ant-design/icons';
import CONSTANT from '../../config/constant';
import { shopInstance } from '../../config/api';
export default class Infomation extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            profile: JSON.parse(localStorage.getItem(CONSTANT.STORAGE_KEY_USER)),
            loading: false,
            agency: null,
            province: null,
            district: null,
            ward: null,
        };
    }
    async componentDidMount() {
        this.loadAgency();
    }
    loadAgency = async () => {
        this.setState({ loading: true });
        try {
            const res = await shopInstance.get(`${CONSTANT.API.AGENCY.AGENCY_INFO}/${this.state.profile._id}`);
            if (res && res.data && res.code === 200) {
                this.setState({ loading: false, agency: res.data });
                
                // Optimize: Use Promise.all to make API calls in parallel
                await Promise.all([
                    this.getProvince(),
                    this.getDistrict(res.data.province, res.data.district),
                    this.getWard(res.data.district, res.data.ward)
                ]);
            }
        } catch (error) {
            message.warning('Lỗi lấy thông tin cửa hàng!', 2.5);
            this.setState({ loading: false });
        }
    }
    getProvince = async () => {
        try {
            const res = await shopInstance.get('/shop/address/get-provinces');
            if (res && res.data && res.code === 200) {
                this.setState({ province: res.data?.docs?.find(item => item._id === this.state.agency.province) });
            }
        } catch (error) {
            console.error('Error fetching provinces:', error);
        }
    }
    getDistrict = async (id, id2) => {
        try {
            const res = await shopInstance.get(`/shop/address/get-districts`, {
                params: {
                    province: id
                }
            });
            if (res && res.data && res.code === 200) {
                this.setState({ district: res.data?.docs?.find(item => item._id === id2) });
            }
        } catch (error) {
            console.error('Error fetching districts:', error);
        }
    }
    getWard = async (id, id2) => {
        try {
            const res = await shopInstance.get(`/shop/address/get-wards`, {
                params: {
                    district: id
                }
            });
            if (res && res.data && res.code === 200) {
                this.setState({ ward: res.data?.docs?.find(item => item._id === id2) });
            }
        } catch (error) {
            console.error('Error fetching wards:', error);
        }
    }


    render() {
        return (
            <div>
                <Breadcrumb style={{ margin: '16px 0' }}>
                    <Breadcrumb.Item >
                        <Link to="/"><HomeOutlined /></Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to="/infomation">Hồ sơ</Link>
                    </Breadcrumb.Item>
                </Breadcrumb>
                <Layout.Content className="layout-content">
                    {
                        this.state.loading &&
                        <div style={{ textAlign: 'center' }}>
                            <Spin />
                        </div>
                    }
                    <Descriptions title="Tài khoản đăng nhập" extra={<Button type="link" onClick={() => this.props.history.push('/profile/user')} >Chi tiết <RightOutlined /></Button>}>
                        <Descriptions.Item label="Mã tài khoản">{this.state.profile._id}</Descriptions.Item>
                        <Descriptions.Item label="Tên đầy đủ">{this.state.profile.firstname + ' ' + this.state.profile.lastname}</Descriptions.Item>
                        <Descriptions.Item label="Email">{this.state.profile.email}</Descriptions.Item>
                        <Descriptions.Item label="Điện thoại">{this.state.profile.phone}</Descriptions.Item>
                    </Descriptions>
                    <Divider />
                    {
                        this.state.agency ? <Descriptions title="Thông tin cửa hàng" extra={<Button type="link" onClick={() => this.props.history.push('/profile/agency')}>Chi tiết <RightOutlined /></Button>}>
                            <Descriptions.Item label="Mã cửa hàng" >{this.state.agency && this.state.agency._id ? this.state.agency._id : ""}</Descriptions.Item>
                            <Descriptions.Item label="Tên cửa hàng">{this.state.agency.name}</Descriptions.Item>
                            <Descriptions.Item label="Email">{this.state.agency.email}</Descriptions.Item>
                            <Descriptions.Item label="Điện thoại">{this.state.agency.phone}</Descriptions.Item>
                            <Descriptions.Item label="Địa chỉ">{this.state.agency.address}</Descriptions.Item>
                            <Descriptions.Item label="Tỉnh/Thành phố">{this.state.province?.name}</Descriptions.Item>
                            <Descriptions.Item label="Quận/Huyện">{this.state.district?.name}</Descriptions.Item>
                            <Descriptions.Item label="Phường/Xã">{this.state.ward?.name}</Descriptions.Item>
                        </Descriptions> : ""
                    }

                </Layout.Content>
            </div>
        )
    }
}